import React, { useState } from 'react'
import { RiCollapseDiagonalLine } from "react-icons/ri";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { FaFilter } from "react-icons/fa";
import { TbReload } from "react-icons/tb";
import { TbArrowsSort } from "react-icons/tb";
import { FaPlus } from "react-icons/fa";





function TTSTemplateRequest() {
    const [showfilter, setshowfilter] = useState(false);
    const [status, setstatus] = useState('')
    const [Agent, setAgent] = useState('')


    function getdata() {
        console.log(status, Agent)
    }

    function clearFilter() {
        setAgent('');
        setstatus('')
    }

    return (
        <>
            <div className='border-b-[1px] border-[#cfcdcd] pb-1'>
                <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>TTS Template Request</h1>
            </div>
            <button className='border-[1px] border-[#3f7fca] text-[#3f7fca] py-2 px-3 flex items-center justify-center gap-1 hover:bg-[#3f7fca] hover:text-[#fff] rounded-md text-[12px] font-semibold mt-4'> <FaPlus /> Add Template</button>
            <div onClick={() => setshowfilter(!showfilter)}
                className='w-[100%] flex justify-between  px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] mt-4'>
                <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                    <RiCollapseDiagonalLine />
                    Filter Records
                </div>
                <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-[#fff] '>
                    {showfilter ? <IoIosArrowDown /> : <IoIosArrowUp />}
                </div>
            </div>
            {showfilter &&
                <div className='bg-[#edf1f5] py-2 px-4 w-[100%] dark:bg-[#121519]'>
                    <div className='w-[100%] flex flex-wrap gap-4'>
                        <div className='w-full sm:w-[48%] lg:w-[24%] flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Template Name </label>
                            <input
                                value={Agent}
                                onChange={(e) => setAgent(e.target.value)}
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                type="text"
                            />
                        </div>

                        <div className='w-full sm:w-[48%] lg:w-[24%] flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Template Status</label>
                            <select
                                value={status}
                                onChange={(e) => setstatus(e.target.value)}
                                className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 dark:bg-[#121519] dark:text-[#fff]'
                            >
                                <option value="">Select Template Status</option>
                                <option value="pending">Pending</option>
                                <option value="Approval">Approval</option>
                                <option value="Rejected">Rejected</option>
                            </select>
                        </div>

                        <div className='w-full sm:w-[48%] lg:w-[24%] flex items-center gap-1 mt-4'>
                            <button
                                onClick={() => getdata()}
                                className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto'
                            >
                                <FaFilter /> <span className='text-[12px] font-bold'>Filter</span>
                            </button>

                            <button
                                onClick={() => clearFilter()}
                                className='flex items-center justify-center border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'
                            >
                                <TbReload /> <span className='text-[12px] font-bold'>Clear Filter</span>
                            </button>
                        </div>

                    </div>
                </div>
            }
           
        </>
    )
}

export default TTSTemplateRequest
